import React from 'react';
import { DuLieuHeThong } from 'api';
import { DropDown } from './common';
import { connect } from 'react-redux';

class DropDownChonQuocTich extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getQuocTich.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'quocTich',
            data: res.data && res.data._embedded && res.data._embedded.quocTiches ? res.data._embedded.quocTiches : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown disabled={this.props.disabled} className={this.props.className} selectedValue={this.props.selectedValue} label="Quốc tịch" options={ this.state.data } keyName='quocTichId' valueName='ten' onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } name="quocTich"/>
    )
  }
}

DropDownChonQuocTich.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  data: [],
  disabled: false
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.quocTich
  }
}

export default connect(bindStateToProps)(DropDownChonQuocTich);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-quoctich.jsx